import Marquee from "react-fast-marquee";

const ITEMS = [
  "Interior",
  "Exterior",
  "Thirty Years",
  "Happy Clients",
  "The Perfect Finish",
  "On Time, Every Time",
];

export default function EditorialMarquee() {
  return (
    <section
      data-testid="editorial-marquee"
      className="border-y border-line py-10 md:py-14 overflow-hidden"
    >
      <Marquee speed={35} gradient={false} autoFill>
        {ITEMS.map((item, i) => (
          <span key={i} className="flex items-center">
            <span
              className={`font-serif italic font-light text-5xl md:text-7xl tracking-tight px-8 md:px-12 ${
                i % 2 === 0 ? "text-outline" : "text-bone/90"
              }`}
            >
              {item}
            </span>
            <span className="block w-2 h-2 bg-ember rotate-45" aria-hidden="true" />
          </span>
        ))}
      </Marquee>
    </section>
  );
}
